//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { fetch } from "@/page/index";

export default {
  data() {
    return {
      isShowViewFile: false,
      showPdfViewModal: false,
      AuthorizationCode: "",
      width: 100,
      pdfDoc: null,
      pages: 0,
      fileUrl: null,
    };
  },
  created() {
    this.AuthorizationCode = this.$store.state.user.authorizationCode;
    // PDF.disableWorker = true
  },
  mounted() {
    // add by lizhen 2022-07-12
    // 把显示组件添加到body显示，避免被其它组件遮挡
    this.$nextTick(() => {
      const body = document.querySelector("body");
      if (body.append) {
        body.append(this.$el);
      } else {
        body.appendChild(this.$el);
      }
    });
  },
  methods: {
    /**浏览PDF文件*/
    open(obj, callback) {
      const _this = this;
      if (!!!obj) {
        _this.$Message.error("无待浏览的文件信息");
        return;
      }
      //_this.showPdfViewModal = true
      _this.filePdfView(obj);
      if (!!callback && callback instanceof "function") {
        callback(obj);
      }
    },
    /**获取路径, 清除多余的/符号*/
    getPathName() {
      let _path = window.location.pathname.match(/(\/)\1+/g);
      if (_path === null || _path === undefined) {
        return "";
      }
      return window.location.pathname.replace(_path[0], "");
    },
    /**浏览PDF文件*/
    filePdfView(obj) {
      if (!!obj && obj.id === undefined) {
        this.pdfjsViewPdf(obj);
      } else {
        this.doFilePdfView(obj);
      }
    },
    doFilePdfView(obj) {
      const _this = this;
      let _pdfFile = { id: obj.id };
      fetch
        .convertFile_baseFile2Pdf(_pdfFile)
        .then((res) => {
          _this.pdfjsViewPdf(res);
          //tabsTool.openTab({url: `/plugins/pdfjs-2.5.207/web/viewer.html?file=${encodeURIComponent(_URL)}`, name: "文件预览"});
        })
        .catch(() => {});
    },
    pdfjsViewPdf(obj) {
      const _this = this;
      let _blob = obj;
      if (obj.blob !== undefined) {
        _blob = obj.blob;
      }
      let _blobData = new Blob([_blob]); // 构造一个blob对象来处理数据
      let _blobUrl = URL.createObjectURL(_blobData);
      let _host = window.location.origin;
      let _config = "#disableRange=true&disableStream=true&disableAutoFetch=true&disableFontFace=true&isEvalSupported=false";
      _this.fileUrl = `https://srmtest.schkzy.com/plugins/pdfjs-2.5.207/web/viewer.html?file=${encodeURIComponent(
        _blobUrl
      )}${_config}`;
      _this.isShowViewFile = true;
      let _timeOutId = setTimeout(() => {
        for (let i = 0; i < window.length; i++) {
          if (window[i].PDFViewerApplication !== undefined) {
            if (obj.isShowPrint !== undefined) {
              window[
                i
              ].PDFViewerApplication.appConfig.toolbar.print.style.display =
                obj.isShowPrint === true ? "" : "none";
            } else {
              window[
                i
              ].PDFViewerApplication.appConfig.toolbar.print.style.display = "";
            }
            if (obj.isShowPrint !== undefined) {
              window[
                i
              ].PDFViewerApplication.appConfig.toolbar.download.style.display =
                obj.isShowPrint === true ? "" : "none";
            } else {
              window[
                i
              ].PDFViewerApplication.appConfig.toolbar.download.style.display =
                "";
            }
          }
        }
        clearTimeout(_timeOutId);
      }, 400);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/PdfJSView.vue